import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Sidebar({ title, links }) {
  return (
    <aside className="ap-side" data-testid="dashboard-sidebar">
      <div className="side-title">{title}</div>
      <div className="side-links">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            className={({ isActive }) => 'side-link' + (isActive ? ' active' : '')}
            data-testid={`side-${l.testid}`}
          >
            {l.label}
          </NavLink>
        ))}
      </div>
    </aside>
  );
}
